import Http from "./Http";

export default {
    async getCountry() {
        return await Http.get('general/country')
    }
}
